import { render, staticRenderFns } from "./manage_child.vue?vue&type=template&id=0168f7b8&scoped=true"
import script from "./manage_child.vue?vue&type=script&lang=js"
export * from "./manage_child.vue?vue&type=script&lang=js"
import style0 from "./manage_child.vue?vue&type=style&index=0&id=0168f7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0168f7b8",
  null
  
)

export default component.exports